import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import setup from './app/setup';
import BootStrapper from './BootStrapper';

if (document.querySelector('#root')) {
   ReactDOM.render(<BootStrapper />, document.querySelector('#root'));
}
